// exam schedule management
export const examScheduleListApi = 'exam-management/exam-schedule/list'
export const examScheduleStoreApi = 'exam-management/exam-schedule/store'
export const examScheduleStatusApi = 'exam-management/exam-schedule/toggle-status'

// subject wise result
export const examSubjectWiseResultListApi = 'exam-management/subject-wise-result/list'
export const examSubjectCoursesListApi = 'exam-management/subject-wise-result/student-courses'
export const examSubjectWiseResultStoreApi = 'exam-management/subject-wise-result/store'
// curriculum progress setting
export const studentInfo = 'student-management/hostel/student'
export const getStudentCurricularApi = 'student-management/individual-assessment/student-curricular'

export const curriculumProgressListApi = 'exam-management/curriculum-progress-setting/list'
export const curriculumProgressDetailApi = 'exam-management/curriculum-progress-setting/show'
export const curriculumProgressReportApi = 'exam-management/curriculum-progress-setting/report'
export const avgCurriculumProgressApi = 'exam-management/curriculum-progress-setting/activity-wise-average'
export const curriculumProgressStoreApi = 'exam-management/curriculum-progress-setting/store'
export const curriculumProgressUpdateApi = 'exam-management/curriculum-progress-setting/update'

// progress letter
export const progressLetterListApi = 'exam-management/progress-letter/list'
export const progressLetterDetailApi = 'exam-management/progress-letter/show'
export const publishResultApi = 'exam-management/progress-letter/publish-result'

// Home work  assessment
export const studentHomeWorkEvalutionList = 'exam-management/home-work-evaluation/list'
export const studentHomeWorkEvalutionDetailsApi = 'exam-management/home-work-evaluation/detail'
export const getStudentHomeWorkEvalutionApi = 'exam-management/home-work-evaluation/information'
export const studentHomeWorkEvalutionStoreApi = 'exam-management/home-work-evaluation/store'
export const studentHomeWorkEvalutionUpdateApi = 'exam-management/home-work-evaluation/update'
export const studentHomeWorkEvalutionReportApi = 'exam-management/home-work-evaluation/report'

// approved result for curriculum, course, homework
export const approveResultApi = 'exam-management/curriculum-progress-setting/approve-result'
